/**
 * Loads the TrustedForm script into the page.  This function has been adapted from the official script provided by
 * ActiveProspect.
 * NOTE THAT THIS FUNCTION DOES DOM MANIPULATION AND MUST BE CALLED FROM THE componentDidMount LIFECYCLE METHOD TO AVOID GASTSBY BUILD ERRORS!
 */
const dangerouslyLoadTrustedFormScript = () => {
  // @TODO maybe clean this up a bit more
  if (typeof document === 'undefined') {
    return
  }
  const field = encodeURI('xxTrustedFormCertUrl')
  const provideReferrer = encodeURI(false)
  const invertFieldSensitivity = false
  const tf = document.createElement('script')
  tf.type = 'text/javascript'
  tf.async = true
  const time = `${new Date().getTime()}${Math.random()}`
  const protocol = document.location.protocol === 'https:' ? 'https' : 'http'
  tf.src = `${protocol}://api.trustedform.com/trustedform.js?provide_referrer=${provideReferrer}&field=${field}&l=${time}&invert_field_sensitivity=${invertFieldSensitivity}`
  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(tf, s)
}

/**
 * Sets field values for TrustedForm fields once they have been loaded.
 * @param form - DOM node of the form the fields will be added to, e.g. formRef.current
 * @param callback - a callback function that will be passed the TrustedForm field values once the fields have been loaded.
 */
const setTrustedFormValues = (form, success, fail) => {
  // The TrustedForm script is an asynchronous script will insert two fields into our form.
  // Since these fields are added after Formik has already initialized, Formik will not know about them so we will
  // need to manually set the values.  Since the fields are added dynamically, we have no way of attaching a ref to
  // them and are forced to use querySelector to find them.
  //
  // This could have been implemented using the trustedFormCertIdCallback and trustedFormCertUrlCallback functions
  // supported by TrustedForm, but that strategy could cause issues if we ever need more than one TCPA form on a page
  // since these callbacks are global and don't provide a way to targeting the form that the values belong to.
  let tries = 0
  const interval = setInterval(() => {
    const tokenField = form.querySelector('[name="xxTrustedFormToken"]')
    const certField = form.querySelector('[name="xxTrustedFormCertUrl"]')
    if (tokenField.value && certField.value) {
      console.log('trusted form fields have arrived', tokenField.value, certField.value)
      clearInterval(interval)
      success({
        token: tokenField.value,
        certURL: certField.value,
      })
    } else {
      tries += 1
      if (tries >= 5) {
        clearInterval(interval)
        fail()
      }
    }
  }, 1000)
}

/**
 * Loads the TrustedForm script into the page and sets the TrustedForm field values into the provided Formik instance
 * once they have been loaded by the script.
 * @param form - DOM node of the form the fields will be added to, e.g. formRef.current
 */
const dangerouslyInitTrustedForm = form =>
  new Promise((resolve, reject) => {
    dangerouslyLoadTrustedFormScript()
    setTrustedFormValues(form, resolve, reject)
  })

export default dangerouslyInitTrustedForm
